import {FC} from 'react'
import {Document} from '../../query'
import {FORMAT} from 'consts/format'
import styles from './ContractSendStatusColumn.scss'

interface ContractSendStatusColumnProps {
  document: Document
}

export const ContractSendStatusColumn: FC<ContractSendStatusColumnProps> = ({document}) => {
  if (document.contractSendStatus === 'canceled') {
    return <span className={styles.canceledText}>取消済</span>
  } else {
    return document.contractSendCount === 0 ? (
      <>{FORMAT.DEFAULT_STRING}</>
    ) : (
      <>{`${document.contractSendCount}/${document.documentEmployeesCount}`}</>
    )
  }
}
